import * as React from "react";
import {ItemListRequest, ItemListResponse, ProductView} from "../../../../generated/protocol";
import {RouterView, LoadingViewState} from "../RouterView";
import {Form, FormListener} from "../../form/Form";
import {Validators} from "../../form/Validators";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {SelectInput} from "../../form/SelectInput";
import {Submit} from "../../form/Submit";
import {DeleteButtonModal} from "../../util/DeleteButtonModal";
import {kernel} from "../../../ioc/IOCHelper";
import {Symbols} from "../../../ioc/Symbols";
import {FormSubmitError, FormSubmitSuccess} from "../../form/FormFeedback";
import {ProductService} from "../../../service/admin/ProductService";
import {ItemService, ITEM_SERVICE_NAME} from "../../../service/admin/ItemService";
import {ListRequest, ItemView} from "../../../../generated/protocol";

interface State extends LoadingViewState {
    product?: ProductView;
    items?: ItemView[];
    validationMap?: any;
}

export class ProductDetailView extends RouterView<{ params: { id: string } }, State> implements FormListener<ProductView> {

    productService: ProductService;
    itemService: ItemService;

    constructor() {
        super();
        this.state = {validationMap: {}, loading: true, items: [], product: {}};
        this.productService = kernel.get<ProductService>(Symbols.ProductService);
        this.itemService = kernel.get<ItemService>(ITEM_SERVICE_NAME);
    }

    loadContent(): Promise<any> {
        return this.init();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.init();
        }
    }

    itemListRequest(): ItemListRequest {
        return {
            category: "AVATAR", // In the future we may need to ask for more than one category... but as of now, we can only sell AVATARS
            limit: 400,
            offset: 0,
            ascending: true,
            orderBy: 'name'
        };
    }

    init(): Promise<any> {
        if (this.props.params.id == "new") {
            return this.load(this.itemService.list(this.itemListRequest())).then(result => {
                let theResult: ItemListResponse = result;
                this.setState({loading: false, items: theResult.items, product: {}});
            });
        } else {
            return this.loadAll(
                this.itemService.list(this.itemListRequest()),
                this.productService.getEntity(this.props.params.id)
            ).then(results => {
                this.setState({
                    loading: false,
                    product: results[1],
                    items: results[0].items
                });
            })
        }
    }

    onSubmit(): Promise<any> {
        return this.productService.save(this.state.product).then((product: ProductView) => {
            if (this.props.params.id == "new") {
                this.navigate("/product/" + product.productId);
            } else {
                this.setState({product: product});
            }
        }).catch((err) => {
            console.error("Server error when submitting form ", err);
            throw err.message;
        });
    }

    onSubmitError() {

    }

    deleteProduct() {
        return this.productService.remove(this.state.product.productId).then(() => {
            this.navigate("/product");
        }).catch((err: axios.Response) => {
            throw "Unable to delete product" + err.statusText;
        });
    }

    formDidUpdate(formModel: ProductView, validationMap: any) {
        this.setState({product: formModel, validationMap: validationMap});
    }

    getItemDisplayValue(item) {
        return item.name;
    }

    renderContent() {

        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Product</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <Form className="form-horizontal" formListener={this}
                          modelObject={this.state.product}
                          validationMap={this.state.validationMap}>


                        <div className="form-group">
                            <div className="col-sm-12">
                                {
                                    this.props.params.id != "new" ?
                                        <DeleteButtonModal description={this.state.product.name}
                                                           className="btn-lg btn-danger pull-right"
                                                           onDelete={this.deleteProduct.bind(this)}/> : <div/>
                                }

                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>Item</h5>
                                    </div>
                                    <div className="ibox-content wizard">
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Item Id</label>
                                            <div className="col-sm-10">

                                                <SelectInput className="form-control" values={this.state.items}
                                                             model="itemId"
                                                             displayValue={this.getItemDisplayValue}
                                                             optionModelValue={(val) => {
                                                                 return val.id;
                                                             }} validators={[Validators.required()]}/>

                                            </div>
                                        </FormGroup>

                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Category</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" model="category"
                                                           validators={[Validators.required(), Validators.textInput()]}
                                                           className="form-control"/>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Currency Code</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" model="currencyCode"
                                                           validators={[Validators.required(), Validators.textInput()]}
                                                           className="form-control"/>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Price</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" model="price"
                                                           validators={[Validators.required(), Validators.textInput()]}
                                                           className="form-control"/>
                                            </div>
                                        </FormGroup>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox-content">
                                    <div className="hr-line-dashed"></div>
                                    <FormSubmitError/>
                                    <FormSubmitSuccess text="Product was updated successfully"/>
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            <Submit className="ladda-button btn-lg btn-primary">Save Product</Submit>
                                        </div>
                                    </div>
                                    <div className="hr-line-dashed"></div>
                                </div>
                            </div>
                        </div>

                    </Form>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/product/ProductConfigView.tsx